'use client';

import type { Product } from '@eliadmin/core/src/api/slugs/types/slug-detail-types';
import { Button, type ButtonProps } from '../ui/button';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useComparisonStore } from '../../stores/comparison-store';
import { MdOutlineBalance } from 'react-icons/md';

export function ProductComparisonButton({
  variant,
  size,
  shadow = true,
  product,
}: {
  variant?: ButtonProps['variant'];
  size?: ButtonProps['size'];
  shadow?: boolean;
  product?: Product;
}) {
  const { t } = useTranslations();
  const toggleProduct = useComparisonStore(s => s.toggleProduct);
  const products = useComparisonStore(s => s.products);

  const active = product ? products.some(p => p.id === product.id) : false;

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (product) {
      toggleProduct(product);
    }
  };

  return (
    <Button
      variant={variant ?? (active ? 'default' : 'white')}
      size={size ?? 'icon'}
      className={cn(shadow && 'ea-product-comparision-button-shadow')}
      onClick={handleClick}
      title={active ? t('text4073') : t('text4072')}
    >
      <MdOutlineBalance size={24} />
    </Button>
  );
}
